import React from 'react';
import { CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { checkoutUrl, mockupUrl, offerAnchor, productName } from '../data/content';
import { checkoutFeatures, offerDescription, pricing } from '../data/bonuses';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
type PricingProps = {
  /** Only the primary offer section carries the #offer anchor id */
  id?: string;
  titleId?: string;
};
export function Pricing({
  id,
  titleId = 'offer-title'
}: PricingProps) {
  return <section id={id} className="scroll-mt-4 bg-plum-900 px-4 py-12 md:py-16" aria-labelledby={titleId} data-id="element-150" data-mp="kadvpajv4pub">
      <div className="mx-auto max-w-xl" data-id="element-151" data-mp="6al6jjnzihog">
        <div className="text-center" data-id="element-152" data-mp="acq2wq5thses">
          <p className="text-[11px] font-black uppercase tracking-[.2em] text-blush-300 md:text-xs" data-id="element-153" data-mp="aboku1qdw5nk">
            Special launch offer
          </p>
          <h2 id={titleId} className="mt-2 text-2xl font-black uppercase leading-tight text-white md:text-4xl" data-id="element-154" data-mp="2r3q0v0m9xej3">
            {productName}
          </h2>
          <p className="mx-auto mt-3 max-w-md text-sm font-semibold leading-relaxed text-white/85" data-id="element-155" data-mp="2fodpzbzuk2qo">
            {offerDescription}
          </p>
        </div>

        <article className="mt-8 rounded-3xl border-4 border-blush-300 bg-white p-6 shadow-2xl md:p-8" data-id="element-156" data-mp="2oo0ui6nvhony">
          <OfferLink href={offerAnchor} className="mx-auto max-w-[300px]" label={`${productName} offer`} data-id="element-157" data-mp="2kmxhdrx7m6qf">
            <img src={mockupUrl} alt={`${productName} 3D product mockup`} className="w-full object-contain transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-158" data-mp="2ylx0kk1ydtf7" />
          </OfferLink>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-wider text-muted" data-id="element-159" data-mp="38eck3lsweq27">
            Here's everything included in your purchase:
          </p>
          <ul className="mx-auto mt-3 flex w-fit flex-col gap-2" data-id="element-160" data-mp="3hdhims4gmjed">
            {checkoutFeatures.map(item => <li key={item} className="flex items-start gap-2 text-sm font-medium text-plum-950" data-id="element-161" data-mp="3cfod81azdtf5">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-berry-600" aria-hidden="true" data-id="element-162" data-mp="2a2a07cz4bl26" />
                {item}
              </li>)}
          </ul>

          <p className="mt-6 rounded-xl bg-blush-100 px-4 py-3 text-center text-sm" data-id="element-163" data-mp="2j02fwi8r4uq3">
            <span className="font-semibold text-plum-900" data-id="element-164" data-mp="2ns3o9t2su1au">5 Bonus Books — Listed Value </span>
            <span className="font-bold text-muted line-through decoration-berry-600 decoration-2" data-id="element-165" data-mp="2srgf0owsjsip">
              ${pricing.bonusValue}
            </span>
            <span className="ml-2 font-black uppercase text-berry-700" data-id="element-166" data-mp="2xs4bhq3sh1kb">Included free</span>
          </p>

          <p className="mt-6 text-center text-xs font-black uppercase tracking-wide text-berry-700" data-id="element-167" data-mp="32n9x0nta4e7v">
            Your special price today
          </p>
          <p className="mt-1 text-center font-display text-5xl font-black text-plum-950" data-id="element-168" data-mp="18c4ytz0yotzx">
            ${pricing.price} <span className="text-base font-bold text-muted" data-id="element-169" data-mp="1cdgdj9iarutc">USD</span>
          </p>
          <div className="mt-5" data-id="element-170" data-mp="14tfiax5zxcr7">
            <Button href={checkoutUrl} size="lg" fullWidth subtext="Get Instant Digital Access" data-id="element-171" data-mp="14ugvb76ko9bk">
              Yes! I want the complete bundle!
            </Button>
          </div>
          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2 text-[10px] font-extrabold uppercase text-muted" data-id="element-172" data-mp="v45rrlqsw257">
            <li className="flex items-center gap-1.5" data-id="element-173" data-mp="qzo9jr039wwj">
              <ZapIcon className="h-3.5 w-3.5 text-berry-600" aria-hidden="true" data-id="element-174" data-mp="1ns9wo51jsb6u" /> Instant PDF Delivery
            </li>
            <li className="flex items-center gap-1.5" data-id="element-175" data-mp="1iu8dzl81advw">
              <LockIcon className="h-3.5 w-3.5 text-berry-600" aria-hidden="true" data-id="element-176" data-mp="1er3gjx2t92e4" /> Secure Payment
            </li>
            <li className="flex items-center gap-1.5" data-id="element-177" data-mp="19t1y9ed7l73p">
              <ShieldCheckIcon className="h-3.5 w-3.5 text-berry-600" aria-hidden="true" data-id="element-178" data-mp="19ud4dku4mqxz" /> 7-Day Guarantee
            </li>
          </ul>
        </article>
      </div>
    </section>;
}